<template>
  <div>
    <div style="display: flex; margin-top: 25px;">
      <div style="margin-left: auto;margin-right: 15%;">
        <el-button type="primary" size="mini" @click="editInfo" v-if="created_1">{{ $t('message.button.edit')
        }}</el-button> <el-button type="success" size="mini" @click="submitForm" v-if="!created_1">{{
            $t('message.button.save')
          }}</el-button>
        <el-button size="mini" @click="closeInfo" v-if="!created_1">{{ $t('message.button.cancel') }}</el-button>
      </div>
    </div>
    <div v-if="created_1">
      <div v-for="item in item_info" :key="item.index" v-if="item.id != 1091003">
        <div style="display: flex;gap: 10px;height: 28px; align-items: center;justify-content: center;">
          <div style="width: 30%;display: flex;">
            <div style="margin-left: auto;">
              {{ item.name }} :
            </div>
          </div>
          <div style="flex: 1;">
            <span v-if="item.id == 1091004">
              <span style="width: 80px;height: 24px; display: inline-block; border-radius: 3px; "
                :style="{ 'background': item.val.val }"></span>
            </span>
            <span v-else class="list-val" :title="item.val.val">{{ item.val.val }}</span>
          </div>
        </div>
      </div>

    </div>
    <div>
      <el-form size="mini" ref="form" label-width="280px" v-if="!created_1" style="margin-top: 40px;">
        <div class="page1" v-for="item in item_info" :model="page_one_data" :key="item.index">
          <div>
            <el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 1">
              <el-input :disabled="!item.editable" :style="input_width" v-model="page_one_data[item.id]"
                @input="upView"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 2">
              <el-input type="textarea" :style="input_width" :disabled="!item.editable" v-model="page_one_data[item.id]"
                @input="upView">
              </el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item :label="item.name + ':'" v-if="item.uiType == 3 && item.id != 1091003"
              :required="item.required">
              <el-select v-if="item.id != 1091004" v-model="page_one_data_select_1[item.id]"
                :placeholder="$t('message.placeholder.select')" :style="input_width" :disabled="!item.editable"
                @change="handleChange">
                <el-option :label='items.name' :value="items.id" v-for="items in item.listEntrie" :key="items.index">
                </el-option>
              </el-select>
              <div v-else>
                <get-color :data="item" @setColor="setColor" />
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item :label="item.name + ':'" v-if="item.uiType == 4" :required="item.required">
              <el-select v-model="page_one_data_select[item.id]" :placeholder="$t('message.placeholder.select')"
                :style="input_width" :disabled="!item.editable" multiple @change="handleChange">
                <el-option :label='items.name' :value="items.id" v-for="items in item.listEntrie" :key="items.index">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item :label="item.name + ':'" v-if="item.uiType == 6" :required="item.required">
              <el-date-picker :style="input_width" v-model="page_one_data[item.id]" type="datetime"
                :placeholder="$t('message.placeholder.pickDate')" @change="handleChange">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import getColor from './getColor.vue';
import { color } from 'echarts';
export default {
  components: { getColor },
  data() {
    return {
      classId: "",
      created_1: true,
      item_info: [],

      page_one_data: {},
      input_width: {
        width: "76%"
      },
      page_one_data_select: {}, //多选

      page_one_data_select_1: {}, //单选

      oldPg1Data: {},//点击编辑后存储现有数据

      oldPg1: {},//旧数据

      oldSel_: {},//旧多选数据

      oldSel_1: {},//旧单选数据

      text_value: "",
      objectId: {},

      themeColor: ''
    }
  },
  mounted() { },
  components: { getColor },
  methods: {
    setColor(val) {
      this.themeColor = val
    },
    closeInfo() {
      this.created_1 = true;
      this.page_one_data = this.deepClone(this.oldPg1);
      this.page_one_data_select = this.deepClone(this.oldSel_);
      this.page_one_data_select_1 = this.deepClone(this.oldSel_1);
    },
    handleChange(val) {
      this.$forceUpdate();
    },
    upView() {
      this.$forceUpdate();
    },
    submitForm() {
      var pg1 = this.page_one_data;
      var sel_ = this.page_one_data_select;
      var sel_1 = this.page_one_data_select_1;
      var sel_val = {};
      for (var key in sel_) {
        var str = this.arrayToString(sel_[key]);
        sel_val[key] = str;
      };
      Object.assign(pg1, sel_val, sel_1);
      var newPg1Data = {};
      for (let key in this.oldPg1Data) {//校验已经修改的数据
        if (this.oldPg1Data[key] !== pg1[key]) {
          newPg1Data[key] = pg1[key];
        };
      };

      const colorItem = this.item_info.find(i => i.id === 1091004)

      const updateUserObj = {
        ... this.$store.state.objectId,        
      };

      if (colorItem) {
        console.log(colorItem, this.themeColor);

        const colorId = colorItem.listEntrie.find(i => i.name === this.themeColor)?.id || null
        updateUserObj['1091004'] = colorId
      }
      Object.assign(updateUserObj, newPg1Data)
      console.log(updateUserObj);
      axios.post('/pmdm/admin/user/updateTable', {//保存按钮            
        updateUserObj,
        tableId: 91
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            this.getTetleBlockInfo();
            this.created_1 = !this.created_1;
          };
        });
    },
    editInfo() {
      this.created_1 = false;
    },
    async getTetleBlockInfo() {
      var obj_get = {
        ... this.$store.state.objectId,
        tableId: 91
      };
      var loadTableUrl = `/pmdm/admin/user/loadTable${this.params(obj_get)}`;
      const { data: res } = await this.$http.get(loadTableUrl);
      this.item_info = this.getNewData(res.object.table.columnInfo) 


      var cls_id = res.object.table.rows[0].objClass;
      var obj_id = res.object.table.rows[0].objId;
      var obj_sbslaid = res.object.table.rows[0].objSubClass;
      this.objectId["classId"] = cls_id;
      this.objectId["id"] = obj_id;
      this.objectId["subClassId"] = obj_sbslaid;
      for (var i = 0;
        i < this.item_info.length;
        i++) {
        this.item_info[i].val = res.object.table.rows[0].cells[i];
        var id_ = this.item_info[i].id + "";
        if (this.item_info[i].uiType == 1 || this.item_info[i].uiType == 2) {
          this.page_one_data[id_] = '';
          let date_ = res.object.table.rows[0].cells[i].val;
          this.page_one_data[id_] = date_;
        };
        if (this.item_info[i].uiType == 3) {
          var date_ = res.object.table.rows[0].cells[i].id;
          if (date_ == -1) {
            this.page_one_data_select_1[id_] = "";
          } else {
            this.page_one_data_select_1[id_] = date_;
          };
        };

        if (this.item_info[i].id == 1091004) {
          var val_name = res.object.table.rows[0].cells[i].val

          this.themeColor = val_name;
          console.log(this.themeColor);


        // var val_name = res.object.table.rows[0].cells[i].val;
        // this.classId = res.object.table.rows[0].cells[i].id;
        // this.page_one_data_select_1[id_] = val_name;
        };
        if (this.item_info[i].uiType == 4) {
          var cells_ = res.object.table.rows[0].cells[i].ids;
          if (cells_ !== "") {
            cells_ = cells_.split(";");
            this.page_one_data_select[id_] = cells_;
          };
        };
        if (this.item_info[i].uiType == 6) {
          this.page_one_data[id_] = '';
          var date_ = res.object.table.rows[0].cells[i].date;
          this.page_one_data[id_] = date_ + "";
        };
      };
      //存储旧数据;
      var pg1 = this.page_one_data;
      var sel_ = this.page_one_data_select;
      var sel_1 = this.page_one_data_select_1;
      var sel_val = {};
      for (var key in sel_) {
        var str = this.arrayToString(sel_[key]);
        sel_val[key] = str;
      };
      this.oldPg1 = this.deepClone(pg1);
      this.oldSel_ = this.deepClone(sel_);
      this.oldSel_1 = this.deepClone(sel_1);
      console.log(this.oldPg1);
      var data1 = Object.assign(pg1, sel_val, sel_1);
      this.oldPg1Data = this.deepClone(data1);
    }
  },
  created() {
    this.getTetleBlockInfo();
  }
};
</script>
<style scoped>
.heading {
  width: 100%;
  float: left;
  margin: 25px 0 18px 0;
}

.heading p {
  font-size: 18px;
  margin: 0;
}

.line01 {
  border-bottom: 1px solid #cecece;
  padding: 10px 0;
}

div {
  font-size: 12px;
}

.table-list {
  height: 20px;
  overflow: hidden;
  margin-top: 4px;
}

.table-list li {
  overflow: hidden;
}

.table-list .list-key {
  display: inline-block;
  width: 42%;
  text-align: right;
  font-size: 14px;
}

.table-list .list-val {
  display: inline-block;
  width: 52%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  font-size: 14px;
  position: relative;
  top: 3px;
}

.table-list .list-key-1 {
  display: inline-block;
  width: 18.5%;
  text-align: right;
  font-size: 14px;
}
</style>
